import PropTypes from 'prop-types'
import React from 'react'
import { useVisualBlocksContext } from '../VisualBlocksContext'
import SplitSubList from './SplitSubList'

function SplitList ({ item }) {
  const { maxListDepth } = useVisualBlocksContext()
  return (
    <div className='flex flex-col gap-1 pl-4' style={{ flexGrow: 2 }}>
      <p className='font-size-lg m-0'>{item.label}</p>
      <div className='flex gap-5' style={{ flexDirection: 'column' }}>
        {item?.details?.map((subItem) => (
          <SplitSubList
            key={subItem.id}
            item={subItem}
            depth={0}
            maxListDepth={maxListDepth}
          />
        ))}
      </div>
    </div>
  )
}

SplitList.propTypes = {
  item: PropTypes.object.isRequired
}

export default SplitList
